import * as React from "react";
import type { SVGProps } from "react";
const SvgMenu05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M10.2 19.2h11.4M2.4 12h19.2M2.4 4.8h19.2"
    />
  </svg>
);
export default SvgMenu05;
